export default class TimerEvent {
    //--------------------------------------------------------------------------
    //
    //  Properties
    //
    //--------------------------------------------------------------------------

    //----------------------------------
    //  Public:
    //----------------------------------

    public static TIMER: string = "TimerEvent:timer";
    public static TIMER_COMPLETE: string = "TimerEvent:timerComplete";
}
